import { IExtractEncryptionStats } from '../types/IExtractEncryptionStats';
import { Request } from './Request';

export interface IGetExtractEncryptionStatsParams {
  id: string;
}

export interface IGetExtractEncryptionStatsResult {
    counts: IExtractEncryptionStats;
}

export class GetExtractEncryptionStatsRequest extends Request<IGetExtractEncryptionStatsParams, IGetExtractEncryptionStatsResult> {
  constructor(params: IGetExtractEncryptionStatsParams) {
    super('getExtractEncryptionStats', params);
  }
}
